export default __webpack_public_path__ + "static/media/edit.5367a649.svg";